var parser = require('ua-parser-js');
var md5 = require('md5');
const { v4: uuidv4 } = require('uuid');

const BEACON_API_URL=process.env.BEACON_API_URL;

export var Analytics = function(orgId, integrationId, url, contentId){

    this.orgId = orgId;
    this.integrationId = integrationId;
    this.contentId = contentId ? contentId : md5(url);

    var ua = new parser();
    var result = ua.getResult();

    this.device = result.device.type;
    this.browser = result.browser.name;
    this.os = result.os.name;
    this.user_agent = result.ua;

    this.ip = "";
    this.country = "";

    try {

        if(localStorage.getItem('l2it_user_token')){

            this.user_token = (localStorage.getItem('l2it_user_token'));
    
        } else {
    
            const l2it_user_token = uuidv4();
    
            localStorage.setItem('l2it_user_token', l2it_user_token);
    
            this.user_token = (l2it_user_token);
    
            this.record('NEW_USER').then(()=>{});
    
        }

    } catch (e) {

        this.user_token = uuidv4();

    }

}

Analytics.prototype = {

    setUserToken: function(userToken){

        this.user_token = userToken;

    },

    fetchCountry: async function(){

        var locationReq = await fetch("https://ipgeolocation.abstractapi.com/v1/?api_key=7c4a5e0655ac45fb8d2cef66ee0ac9f9");
        var location = await locationReq.json();
    
        this.ip = location.ip_address;
        this.country = location.country;

    },

    record: async function(name, payload){

        if (!this.user_token) return;

        if(""==this.ip){

            await this.fetchCountry();

        }

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
    
        var raw = JSON.stringify({
            "timestamp": new Date().toISOString(),
            "org_id": this.orgId,
            "integration_id": this.integrationId,
            "content_id": this.contentId,
            "event_name": name,
            "user_token": this.user_token,
            "ip": this.ip,
            "country": this.country,
            "device": this.device,
            "browser": this.browser,
            "operating_system": this.os,
            "user_agent": this.user_agent,
            'payload': payload
        });
    
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
    
        await fetch(`${BEACON_API_URL}/record`, requestOptions);

    }

}